import { component } from 'picoapp';

import attachBw26Specular from 'utils/bw26-specular';

export default component((node, ctx) => {
  const { formId, productId } = node.dataset;
  const detachSpecular = node.classList.contains('button--restyle--bw26')
    ? attachBw26Specular(node)
    : null;

  const handleUpdate = (e) => {
    e.stopPropagation();

    const { currentProductId } = e.detail;
    const { forms } = ctx.getState();
    const { selectedVariant } = forms[currentProductId];

    if (!selectedVariant) {
      node.disabled = true;
      node.classList.add('no-variant', 'opacity-30');
      node.classList.remove('sold-out', 'available');
    } else if (selectedVariant?.available) {
      node.disabled = false;
      node.classList.add('available');
      node.classList.remove('sold-out', 'no-variant', 'opacity-30');
    } else {
      node.disabled = node.type === 'submit';
      node.classList.remove('available', 'no-variant');
      node.classList.add('sold-out', 'opacity-30');
    }
  };

  const handleLoading = (e) => {
    e.stopPropagation();

    node.classList.add('is-loading');
    node.classList.remove('available');
  };

  const handleLoadingDone = (e) => {
    e.stopPropagation();

    node.classList.remove('is-loading');
    node.classList.add('available');
  };

  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);
  document.addEventListener(`product:${formId}:loading`, handleLoading);
  document.addEventListener(`product:${formId}:loading-done`, handleLoadingDone);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
      document.removeEventListener(`product:${formId}:loading`, handleLoading);
      document.removeEventListener(`product:${formId}:loading-done`, handleLoadingDone);
      detachSpecular?.();
    },
    { once: true },
  );
});
